import {IFetchContext} from "@pg-mono/data-fetcher";
import {noop} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {safelyParsePage} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {descriptionVendorDetail} from "../../meta_data/page_description/vendor_detail";
import {descriptionVendorList} from "../../meta_data/page_description/vendor_list";
import {titleVendorDetail} from "../../meta_data/page_title/vendor_detail";
import {titleVendorList} from "../../meta_data/page_title/vendor_list";
import {generatePrevNextMetaLinks} from "../../meta_data/utils/generate_prev_next_links";
import {trimAggregationFromRegion} from "../../meta_data/utils/trim_aggregation_from_region";
import {IRootState} from "../../store/store";
import {calculateVendorListMaxPage} from "../helpers/calculate_vendor_list_max_page";
import {IVendorDetail} from "../types/IVendorDetail";
import {IVendorDetailCity} from "./fetch_vendor_detail_cities";

export const updateVendorListMetaData =
    ({route}: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {page, name, ...restQuery} = route.query;

        const parsedPage = safelyParsePage(page);

        const region = getState().vendor.list.region;
        const {count} = getState().vendor.list;

        const maxPage = calculateVendorListMaxPage(getState().vendor.list);

        const regionSEOMetadata = getState().vendor.list.regionSEOMetadata;

        const fullPath = `${rpCommonUrl}${route.pathname}`;
        const {prev, next} = generatePrevNextMetaLinks(parsedPage, maxPage, fullPath, restQuery);
        const title =
            (regionSEOMetadata && regionSEOMetadata.meta_title) ||
            titleVendorList({
                region: region && region[0],
                page: parsedPage
            });

        const description =
            regionSEOMetadata?.meta_description ||
            descriptionVendorList({
                count,
                region: region && region[0],
                page: parsedPage
            });
        const robots = regionSEOMetadata?.is_indexed || !!region?.length || (!region?.length && parsedPage === 1) ? "index, follow" : "noindex, follow";
        const customCanonicalPath =
            regionSEOMetadata?.canonical_url ?? appendQueryString(trimAggregationFromRegion(route.pathname), {page: parsedPage === 1 ? noop() : parsedPage});

        const metaData = updateMetaData({
            title,
            description,
            pathname: route.pathname,
            robots,
            customCanonicalPath,
            pageNumber: parsedPage,
            next,
            prev
        });
        dispatch(metaData);
        return true;
    };

const VENDOR_DETAIL_CANONICAL_QUERY_KEYS = ["lokalizacja", "typ"] as const;

function getVendorDetailCanonicalPath(pathname: string, query: Record<string, unknown>): string {
    const canonicalQuery: Record<string, string> = {};

    for (const key of VENDOR_DETAIL_CANONICAL_QUERY_KEYS) {
        const value = query[key];

        if (value !== undefined && value !== null && value !== "") {
            canonicalQuery[key] = String(value);
        }
    }

    return appendQueryString(pathname, canonicalQuery);
}

function getVendorDetailMetaPayload(vendor: IVendorDetail, cities: IVendorDetailCity[] | null, pathname: string, query: Record<string, unknown>) {
    const locationSlug = query?.lokalizacja as string | string[] | undefined;
    const locationSlugStr = typeof locationSlug === "string" ? locationSlug : Array.isArray(locationSlug) ? locationSlug[0] : undefined;
    const city = locationSlugStr && cities?.length ? (cities.find((c) => c.slug === locationSlugStr) ?? null) : null;
    const cityName = city?.name;

    const title = titleVendorDetail(vendor.type, vendor.name, cityName);
    const description = descriptionVendorDetail(vendor.type, vendor.name, cityName);
    const robots = vendor.configuration.meta_robots ?? (vendor.is_indexing_allowed ? "index, follow" : "noindex, follow");
    const customCanonicalPath = getVendorDetailCanonicalPath(pathname, query);

    return {title, description, pathname, robots, customCanonicalPath};
}

/** Call when URL (pathname/search) changes on client so canonical, title and description stay in sync (e.g. after tab switch). */
export const syncVendorDetailMetaDataFromLocation =
    (pathname: string, query: Record<string, unknown>) => (dispatch: MetaDataDispatch, getState: () => IRootState) => {
        const {vendor, cities} = getState().vendor.detail;

        if (!vendor) return;

        const payload = getVendorDetailMetaPayload(vendor, cities, pathname, query);

        dispatch(updateMetaData(payload));
    };

export const updateVendorDetailMetaData =
    ({route}: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: MetaDataDispatch, getState: () => IRootState) => {
        const {vendor, cities} = getState().vendor.detail;

        if (vendor) {
            const payload = getVendorDetailMetaPayload(vendor, cities, route.pathname, route.query as Record<string, unknown>);

            dispatch(updateMetaData(payload));
        }

        return true;
    };
import {IFetchContext} from "@pg-mono/data-fetcher";
import {noop} from "@pg-mono/nodash";
import {appendQueryString} from "@pg-mono/request";
import {safelyParsePage} from "@pg-mono/string-utils";

import {rpCommonUrl} from "../../app/read_rp_environment_variables";
import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {descriptionVendorDetail} from "../../meta_data/page_description/vendor_detail";
import {descriptionVendorList} from "../../meta_data/page_description/vendor_list";
import {titleVendorDetail} from "../../meta_data/page_title/vendor_detail";
import {titleVendorList} from "../../meta_data/page_title/vendor_list";
import {generatePrevNextMetaLinks} from "../../meta_data/utils/generate_prev_next_links";
import {trimAggregationFromRegion} from "../../meta_data/utils/trim_aggregation_from_region";
import {IRootState} from "../../store/store";
import {calculateVendorListMaxPage} from "../helpers/calculate_vendor_list_max_page";
import {IVendorDetail} from "../types/IVendorDetail";
import {IVendorDetailCity} from "./fetch_vendor_detail_cities";

export const updateVendorListMetaData =
    ({route}: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: MetaDataDispatch, getState: () => IRPStore) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const {page, name, ...restQuery} = route.query;

        const parsedPage = safelyParsePage(page);

        const region = getState().vendor.list.region;
        const {count} = getState().vendor.list;

        const maxPage = calculateVendorListMaxPage(getState().vendor.list);

        const regionSEOMetadata = getState().vendor.list.regionSEOMetadata;

        const fullPath = `${rpCommonUrl}${route.pathname}`;
        const {prev, next} = generatePrevNextMetaLinks(parsedPage, maxPage, fullPath, restQuery);
        const title =
            (regionSEOMetadata && regionSEOMetadata.meta_title) ||
            titleVendorList({
                region: region && region[0],
                page: parsedPage
            });

        const description =
            regionSEOMetadata?.meta_description ||
            descriptionVendorList({
                count,
                region: region && region[0],
                page: parsedPage
            });
        const robots = regionSEOMetadata?.is_indexed || !!region?.length || (!region?.length && parsedPage === 1) ? "index, follow" : "noindex, follow";
        const customCanonicalPath =
            regionSEOMetadata?.canonical_url ?? appendQueryString(trimAggregationFromRegion(route.pathname), {page: parsedPage === 1 ? noop() : parsedPage});

        const metaData = updateMetaData({
            title,
            description,
            pathname: route.pathname,
            robots,
            customCanonicalPath,
            pageNumber: parsedPage,
            next,
            prev
        });
        dispatch(metaData);
        return true;
    };

const VENDOR_DETAIL_CANONICAL_QUERY_KEYS = ["lokalizacja", "typ"] as const;

function getVendorDetailCanonicalPath(pathname: string, query: Record<string, unknown>): string {
    const canonicalQuery: Record<string, string> = {};

    for (const key of VENDOR_DETAIL_CANONICAL_QUERY_KEYS) {
        const value = query[key];

        if (value !== undefined && value !== null && value !== "") {
            canonicalQuery[key] = String(value);
        }
    }

    return appendQueryString(pathname, canonicalQuery);
}

function getVendorDetailMetaPayload(vendor: IVendorDetail, cities: IVendorDetailCity[] | null, pathname: string, query: Record<string, unknown>) {
    const locationSlug = query?.lokalizacja as string | string[] | undefined;
    const locationSlugStr = typeof locationSlug === "string" ? locationSlug : Array.isArray(locationSlug) ? locationSlug[0] : undefined;
    const city = locationSlugStr && cities?.length ? (cities.find((c) => c.slug === locationSlugStr) ?? null) : null;
    const cityName = city?.name;

    const title = titleVendorDetail(vendor.type, vendor.name, cityName);
    const description = descriptionVendorDetail(vendor.type, vendor.name, cityName);
    const robots = vendor.configuration.meta_robots ?? (vendor.is_indexing_allowed ? "index, follow" : "noindex, follow");
    const customCanonicalPath = getVendorDetailCanonicalPath(pathname, query);

    return {title, description, pathname, robots, customCanonicalPath};
}

/** Call when URL (pathname/search) changes on client so canonical, title and description stay in sync (e.g. after tab switch). */
export const syncVendorDetailMetaDataFromLocation =
    (pathname: string, query: Record<string, unknown>) => (dispatch: MetaDataDispatch, getState: () => IRootState) => {
        const {vendor, cities} = getState().vendor.detail;

        if (!vendor) return;

        const payload = getVendorDetailMetaPayload(vendor, cities, pathname, query);

        dispatch(updateMetaData(payload));
    };

export const updateVendorDetailMetaData =
    ({route}: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: MetaDataDispatch, getState: () => IRootState) => {
        const {vendor, cities} = getState().vendor.detail;

        if (vendor) {
            const payload = getVendorDetailMetaPayload(vendor, cities, route.pathname, route.query as Record<string, unknown>);

            dispatch(updateMetaData(payload));
        }

        return true;
    };
